import React from "react";

const radioUnselected = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="21"
		height="21"
		viewBox="0 0 21 21"
		fill="none"
	>
		<path
			d="M10.5 0C9.05078 0 7.68359 0.273438 6.39844 0.820312C5.12695 1.36719 4.0127 2.11914 3.05566 3.07617C2.1123 4.01953 1.36719 5.13379 0.820312 6.41894C0.273438 7.69043 0 9.05078 0 10.5C0 11.9492 0.273438 13.3164 0.820312 14.6016C1.36719 15.873 2.1123 16.9873 3.05566 17.9443C4.0127 18.8877 5.12695 19.6328 6.39844 20.1797C7.68359 20.7266 9.05078 21 10.5 21C11.9492 21 13.3096 20.7266 14.5811 20.1797C15.8662 19.6328 16.9805 18.8877 17.9238 17.9443C18.8809 16.9873 19.6328 15.873 20.1797 14.6016C20.7266 13.3164 21 11.9492 21 10.5C21 9.05078 20.7266 7.69043 20.1797 6.41894C19.6328 5.13379 18.8809 4.01953 17.9238 3.07617C16.9805 2.11914 15.8662 1.36719 14.5811 0.820312C13.3096 0.273438 11.9492 0 10.5 0ZM10.5 19.6875C9.22852 19.6875 8.03223 19.4482 6.91113 18.9697C5.80371 18.4912 4.83301 17.835 3.99902 17.001C3.16504 16.167 2.50879 15.1963 2.03027 14.0889C1.55176 12.9678 1.3125 11.7715 1.3125 10.5C1.3125 9.22852 1.55176 8.03906 2.03027 6.93164C2.50879 5.81055 3.16504 4.83301 3.99902 3.99902C4.83301 3.16504 5.80371 2.50879 6.91113 2.03027C8.03223 1.55176 9.22852 1.3125 10.5 1.3125C11.7715 1.3125 12.9609 1.55176 14.0684 2.03027C15.1895 2.50879 16.167 3.16504 17.001 3.99902C17.835 4.83301 18.4912 5.81055 18.9697 6.93164C19.4482 8.03906 19.6875 9.22852 19.6875 10.5C19.6875 11.7715 19.4482 12.9678 18.9697 14.0889C18.4912 15.1963 17.835 16.167 17.001 17.001C16.167 17.835 15.1895 18.4912 14.0684 18.9697C12.9609 19.4482 11.7715 19.6875 10.5 19.6875Z"
			fill="#CCCCCC"
		/>
	</svg>
);

const radioSelected = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="21"
		height="21"
		viewBox="0 0 21 21"
		fill="none"
	>
		<path
			d="M10.5 0C9.05078 0 7.68359 0.273438 6.39844 0.820312C5.12695 1.36719 4.0127 2.11914 3.05566 3.07617C2.1123 4.01953 1.36719 5.13379 0.820312 6.41894C0.273438 7.69043 0 9.05078 0 10.5C0 11.9492 0.273438 13.3164 0.820312 14.6016C1.36719 15.873 2.1123 16.9873 3.05566 17.9443C4.0127 18.8877 5.12695 19.6328 6.39844 20.1797C7.68359 20.7266 9.05078 21 10.5 21C11.9492 21 13.3096 20.7266 14.5811 20.1797C15.8662 19.6328 16.9805 18.8877 17.9238 17.9443C18.8809 16.9873 19.6328 15.873 20.1797 14.6016C20.7266 13.3164 21 11.9492 21 10.5C21 9.05078 20.7266 7.69043 20.1797 6.41894C19.6328 5.13379 18.8809 4.01953 17.9238 3.07617C16.9805 2.11914 15.8662 1.36719 14.5811 0.820312C13.3096 0.273438 11.9492 0 10.5 0ZM10.5 19.6875C9.22852 19.6875 8.03223 19.4482 6.91113 18.9697C5.80371 18.4912 4.83301 17.835 3.99902 17.001C3.16504 16.167 2.50879 15.1963 2.03027 14.0889C1.55176 12.9678 1.3125 11.7715 1.3125 10.5C1.3125 9.22852 1.55176 8.03906 2.03027 6.93164C2.50879 5.81055 3.16504 4.83301 3.99902 3.99902C4.83301 3.16504 5.80371 2.50879 6.91113 2.03027C8.03223 1.55176 9.22852 1.3125 10.5 1.3125C11.7715 1.3125 12.9609 1.55176 14.0684 2.03027C15.1895 2.50879 16.167 3.16504 17.001 3.99902C17.835 4.83301 18.4912 5.81055 18.9697 6.93164C19.4482 8.03906 19.6875 9.22852 19.6875 10.5C19.6875 11.7715 19.4482 12.9678 18.9697 14.0889C18.4912 15.1963 17.835 16.167 17.001 17.001C16.167 17.835 15.1895 18.4912 14.0684 18.9697C12.9609 19.4482 11.7715 19.6875 10.5 19.6875Z"
			fill="#222222"
		/>
		<circle cx="10.5" cy="10.5" r="6.5" fill="#F8B912" />
	</svg>
);

const checkboxUnselected = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="23"
		height="23"
		viewBox="0 0 23 23"
		fill="none"
	>
		<rect
			x="0.5"
			y="0.5"
			width="22"
			height="22"
			rx="2.5"
			fill="white"
			stroke="#CCCCCC"
		/>
	</svg>
);

const checkboxSelected = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="23"
		height="23"
		viewBox="0 0 23 23"
		fill="none"
	>
		<rect
			x="0.5"
			y="0.5"
			width="22"
			height="22"
			rx="2.5"
			fill="white"
			stroke="#222222"
		/>
		<path
			d="M17.0263 6.52631L9.84211 13.7105L5.97369 9.84209L4.3158 11.5L9.84211 17.0263L18.6842 8.1842L17.0263 6.52631Z"
			fill="#222222"
		/>
	</svg>
);

export default {
	radioSelected,
	radioUnselected,
	checkboxUnselected,
	checkboxSelected,
};
